/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useMemo, useState } from "react";
import { Container } from "@material-ui/core";
import PageTitle from "../../../../components/pageTitle/PageTitle";
import moment from "moment-timezone";
import * as Excel from "exceljs";
import { downloadPDF, downloadExcel } from "../../DownloadReportUtils";
import { getUserActivity } from "../../../../services/apiservices/activity";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import AuthContext from "../../../../hooks/authContext";
import ActionRender from "../../ActionRender";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../../../components/ui/card";
import {
  Download,
  FileSpreadsheet,
  FileText,
  Filter,
  Mail,
} from "lucide-react";
import { Label } from "../../../../components/ui/label";
import ThemeTable from "../../../../components/Table/ThemeTable";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../../../components/ui/popover";
import { Button } from "../../../../components/ui/button";
import MultiSelectWithCheckbox from "../../../../components/SelectField/MulitpleSelectNew";
import { getCompanyEmployees } from "../../../../services/apiservices/employee";
import EmailReports from "../../EmailReports";
import { CSVLink } from "react-csv";
import { MobileActivityReport } from "../MobileViewReports";
import { getSettings } from "../../../../services/apiservices/settings";

function ActivityReportNew(props) {
  const csvHeaders = [
    "Employee Name",
    "Date",
    "Version Of the App(Device)",
    "Action",
  ];

  const [employeeList, setEmployeeList] = useState([]);
  const [employeeListMaster, setEmployeeListMaster] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [clientsListCSV, setClientListCSV] = useState([csvHeaders]);
  const [endDate, setEndDate] = useState(null);
  const [empName, setEmpName] = useState([]);
  const [empNameList, setEmpNameList] = useState([]);
  const [employee, setEmployee] = useState();
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const [settingsData, setSettingsData] = useState();
  const [openEmailDialog, setOpenEmailDialog] = useState(false);
  const isMobile = useMediaQuery("(max-width:767px)");
  const isLandscape = useMediaQuery(
    "(min-width: 771px) and (max-width: 940px)"
  );
  const auth = useContext(AuthContext);
  const { setReportData } = auth || {};
  const companyId =
    auth?.userProfile?.role === "companyUser"
      ? auth?.userProfile?.id
      : auth?.userProfile?.companyId;

  const getColumns = () => {
    const columns = [
      {
        id: "employeeName",
        numeric: false,
        disablePadding: false,
        label: "Name",
        isSortable: false,
      },
      {
        id: "date",
        numeric: false,
        disablePadding: false,
        label: "Date",
        isSortable: false,
      },
      {
        id: "version",
        numeric: false,
        disablePadding: false,
        label: "Version Of the App(Device)",
        isSortable: false,
      },
      {
        id: "actions",
        numeric: false,
        disablePadding: false,
        label: "Action",
        isSortable: false,
      },
      {
        id: "Action",
        numeric: false,
        disablePadding: false,
        label: "Actions",
        isSortable: false,
      },
    ];

    if (isMobile || isLandscape) {
      return columns.filter(
        (col) =>
          col.id !== "employeeName" && col.id !== "date" && col.id !== "Action"
      );
    }
    return columns;
  };

  useEffect(() => {
    const getEmployeesData = async () => {
      const [employeeRes, settingsRes] = await Promise.all([
        new Promise((resolve, reject) => { getCompanyEmployees(companyId, (res) => resolve(res), (err) => resolve({ status: false, data: [] }));}),
        new Promise((resolve) => getSettings("client_settings", companyId, (res) => resolve(res?.data))),
      ]);
      const details = employeeRes?.data;
      const employee = details?.map((item) => {
        return {
          value: item?.id,
          label: `${item?.firstName} ${item?.lastName}`,
        };
      })?.sort((a, b) => a?.label?.localeCompare(b?.label));
      const filteredData = settingsRes?.filter(
        (item) => !item.deleted
      );
      setSettingsData(filteredData?.length ? filteredData : []);
      setEmployee(details);
      setEmpNameList([...employee]);
    };
    getEmployeesData();
  }, []);

  const getDatatoDownload = (rcellItem) => {
    let clientCSV = [];
    if (!Array.isArray(rcellItem)) {
      clientCSV = employeeList?.filter(
        (item) => item.employeNameId === rcellItem.employeNameId
      );
      clientCSV = clientCSV?.map((item) => {
        return [item?.employeeName, item?.date, item?.version, item?.actions];
      });
    } else {
      clientCSV = rcellItem?.map((item) => {
        return [item?.employeeName, item?.date, item?.version, item?.actions];
      });
    }
    return clientCSV;
  };

  const getDatatoFullDownload = (rcellItem) => {
    if (rcellItem) {
      employeeList?.filter(
        (item) => item.employeNameId === rcellItem.employeNameId
      );
      return [
        rcellItem?.employeeName,
        rcellItem?.date,
        rcellItem?.version,
        rcellItem?.actions,
      ];
    } else {
      return [
        rcellItem?.employeeName,
        rcellItem?.date,
        rcellItem?.version,
        rcellItem?.actions,
      ];
    }
  };

  const downloadForExcel = async (rcellItem, date, emailSend) => {
    let wb = new Excel.Workbook();
    let ws = wb.addWorksheet("Activity Report");
    const dates =`${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format( "YYYY-MM-DD")}`;

    const clientCSV = getDatatoDownload(rcellItem?.records ? rcellItem?.records : rcellItem);
    let fileName;
    if (Array.isArray(rcellItem?.records)) {
      if (rcellItem?.records?.length === 1) {
        fileName = `ActivityReport_${rcellItem?.records?.[0].employeeName}_${dates}`;
      } else {
        fileName = `ActivityReport_All_${dates}`;
      }
    } else {
      fileName = `ActivityReport_${rcellItem.employeeName}_${dates}`;
    }
    let name = true;
    return await downloadExcel(
      clientCSV,
      csvHeaders,
      wb,
      ws,
      fileName,
      emailSend,
      name
    );
  };

  const downloadForPDF = async (rcellItem, date, emailSend) => {
    const clientCSV = getDatatoDownload(rcellItem?.records ? rcellItem?.records : rcellItem);
    const dates = `${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    let fileName;
    if (Array.isArray(rcellItem?.records)) {
      if (rcellItem?.records?.length === 1) {
        fileName = `ActivityReport_${rcellItem?.records?.[0].employeeName}_${dates}`;
      } else {
        fileName = `ActivityReport_All_${dates}`;
      }
    } else {
      fileName = `ActivityReport_${rcellItem.employeeName}_${dates}`;
    }
    let name = true;
    const logo = settingsData?.[0]?.companyLogo;
    return await downloadPDF(logo, clientCSV, csvHeaders, fileName, emailSend, name);
  };

  const setDownloadCSVData = (event, done, rcellItem, date) => {
    const clientCSV = getDatatoDownload(rcellItem?.records ? rcellItem?.records : rcellItem);

    const reportName = "Activity Report";

    const employeName = Array.isArray(rcellItem?.records)
      ? rcellItem?.records?.length === 1
        ? `${rcellItem?.records?.[0].employeeName}`
        : `All`
      : `${rcellItem.employeeName}`;
    const reportPeriod =`${moment(startDate).format("YYYY-MM-DD")} to ${moment(
            endDate
          ).format("YYYY-MM-DD")}`;
    // Create the report details rows
    const reportDetails = [
      [`Employee Name: ${employeName}`],
      [`Report Name: ${reportName}`],
      [`Report Period: ${reportPeriod}`],
      [],
      [...csvHeaders],
      ...clientCSV,
    ];
    // Set the CSV data
    setClientListCSV(reportDetails);
    done();
  };

  const setDownloadFullCSVData = (event, done) => {
    const clientCSV = employeeList?.map((item) => getDatatoFullDownload(item));
    let empNamefordwonLoad = "All";
    if (empName.length !== 0 && empName.length !== empNameList.length) {
      const names = empNameList
        .filter((item) => empName?.includes(item.value))
        .map((emp) => emp.label);
      empNamefordwonLoad = names.join(", ");
    } else if (empName.length === 0) {
      empNamefordwonLoad = "All";
    }
    
    const reportName = "Activity Report";
    const reportPeriod = `${moment(startDate).format("YYYY-MM-DD")} to ${moment(endDate).format("YYYY-MM-DD")}`;
  
    const reportDetails = [
      [`Employee Name: ${empNamefordwonLoad}`],
      [`Report Name: ${reportName}`],
      [`Report Period: ${reportPeriod}`],
      [],
      [...csvHeaders],
      ...clientCSV
      ];
  
    setClientListCSV(reportDetails);
    done();
  };

  const downloadForFullPDF = async (emailSend) => {
    const clientCSV = employeeList.map((item) => getDatatoFullDownload(item));
    let empNamefordwonLoad = "All";
    if (empName.length !== 0 && empName.length !== empNameList.length) {
      // Extracting labels
      const names = empNameList
        .filter((item) => empName.includes(item.value))
        .map((emp) => emp.label);
      empNamefordwonLoad = names.join(", ");
    } else if (empName.length === 0) {
      empNamefordwonLoad = "All";
    }
    let fileName = `ActivityReport_${empNamefordwonLoad}_${moment(
      startDate
    ).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    let name = true;
    const logo = settingsData?.[0]?.companyLogo;
    return await downloadPDF(logo, clientCSV, csvHeaders, fileName, emailSend, name);
  };

  const downloadForFullExcel = async (emailSend) => {
    let wb = new Excel.Workbook();
    let ws = wb.addWorksheet("Activity Report");
    let empNamefordwonLoad = "All";

    const clientCSV = employeeList.map((item) => getDatatoFullDownload(item));

    if (empName !== "All") {
      const names = empNameList
        .filter((item) => empName.includes(item.value))
        .map((emp) => emp.label);
      empNamefordwonLoad = names.join(", ");
    }
    let fileName = `ActivityReport_${empNamefordwonLoad}_${moment(
      startDate
    ).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    let name = true;
    return await downloadExcel(
      clientCSV,
      csvHeaders,
      wb,
      ws,
      fileName,
      emailSend,
      name
    );
  };

  const handleEmailIconClick = async (rcellItem, date) => {
    const emailSend = true;
    let name;
    if (Array.isArray(rcellItem?.records)) {
      if (rcellItem?.records?.length === 1) {
        name = rcellItem?.records?.[0]?.employeeName;
      } else {
        name = "All";
      }
    } else {
      name = rcellItem?.employeeName;
    }

    const Dates = `${startDate}`;
    const [excelBlob, pdfBlob] = await Promise.all([
      downloadForExcel(rcellItem, date, emailSend),
      downloadForPDF(rcellItem, date, emailSend),
    ]);
    // Convert the Excel blob to a base64-encoded string
    const reader = new FileReader();
    reader.readAsDataURL(excelBlob);
    reader.onloadend = function () {
      const base64Data = reader.result;
      setReportData((prev) => ({
        ...prev,
        FileName: "ActivityReport",
        ReportsName: "Employee Report",
        Name: name,
        Date: Dates,
        EndDate: endDate,
        pdf: pdfBlob,
        storedData: base64Data,
        fullData: "",
        fullExcelData: "",
      }));
      setOpenEmailDialog(true);
    };
  };

  const handelEmailFullReport = async () => {
    const emailSend = true;

    let empNamefordwonLoad = "All";

    if (empName.length !== 0 && empName.length !== empNameList.length) {
      // Extracting labels
      const names = empNameList
        ?.filter((item) => empName.includes(item.value))
        ?.map((emp) => emp?.label);
      empNamefordwonLoad = names.join(", ");
    }

    const [fullReport, fullExcelReport] = await Promise.all([
      downloadForFullPDF(emailSend),
      downloadForFullExcel(emailSend),
    ]);
    const reader = new FileReader();
    reader.readAsDataURL(fullExcelReport);
    reader.onloadend = function () {
      const base64Data = reader.result;
      setReportData((prev) => ({
        ...prev,
        FileName: "ActivityReport",
        ReportsName: "Employee Report",
        Name: empNamefordwonLoad,
        Date: startDate,
        EndDate: endDate,
        fullData: fullReport,
        fullExcelData: base64Data,
        pdf: "",
        storedData: "",
      }));
      setOpenEmailDialog(true);
    };
  };

  const handleEmpNameChange = (e) => {
    setEmpName(e);
    if (!e || e?.length === 0) {
      setEmployeeList(employeeListMaster);
    } else {
      setEmployeeList(employeeListMaster?.filter((item) => e?.includes(item?.employeNameId)));
    }
  };

  const handleGenerateReport = async() => {
    setLoader(true);
    let paramStartDate = "";
    let paramEndDate = "";

    paramStartDate = startDate;
    paramEndDate = endDate;
    getReportListData(paramStartDate, paramEndDate);
  };

  const mapWidhtEmpList = (timeSheet) => {
    try {
      const userDataToUpdate = timeSheet
        ?.filter((data) =>
          empNameList?.some((emp) => emp.value === data.userId)
        )
        ?.sort((a, b) => a.createdOn.seconds - b.createdOn.seconds);
      const userDataMap = {};
      userDataToUpdate.forEach((item) => {
        if (!userDataMap[item.userId]) {
          userDataMap[item.userId] = [];
        }
        const user = employee?.find((u) => u.id === item.userId);
        const userTimeZone = user?.timeZone || "America/New_York";

        if (item.createdOn?.seconds) {
          const date = moment
            .unix(item.createdOn.seconds)
            .tz(userTimeZone)
            .format("ll");
          const timeFormats = moment
            .unix(item.createdOn.seconds)
            .tz(userTimeZone)
            .format("hh:mm A");
          const actions = `${item.type} (${timeFormats})`;

          userDataMap[item.userId].push({
            date: date,
            version: item.version
              ? `${item.version} (${
                  parseFloat(item.version) < 0 ? "Web" : item.device || ""
                })`
              : "---",
            actions: actions,
          });
        } else {
          console.warn("Missing createdOn field in timesheet data:", item);
        }
      });

      const employeeListMaster = [];
      for (const userId in userDataMap) {
        const user = employee?.find((item) => item.id === userId);
        if (user) {
          const userActivities = userDataMap[userId].map((activity) => ({
            employeeName: `${user.firstName} ${user.lastName}`,
            employeNameId: userId,
            date: activity.date,
            version: activity.version,
            actions: activity.actions,
          }));
          employeeListMaster.push(...userActivities);
        }
      }

      const sortedData = sortingFunction(employeeListMaster);
      setEmployeeListMaster(sortedData);
      setEmployeeList(
        sortedData.filter((item) =>
          empName.length > 0 ? empName.includes(item.employeNameId) : true
        )
      );
      setLoader(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const sortingFunction = (data) => {
    const result = data.sort((a, b) => {
      if (a.employeeName < b.employeeName) return -1;
      if (a.employeeName > b.employeeName) return 1;

      // Parse the date strings into Date objects for correct comparison
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);

      if (dateA < dateB) return -1;
      if (dateA > dateB) return 1;

      return 0;
    });

    return result;
  };

  const getReportListData = async (startDt, endDt) => {
    const startDate = `${dayjs(startDt).format("YYYY-MM-DD")}T00:00:00`;
    const endDate = `${dayjs(endDt).format("YYYY-MM-DD")}T23:59:59`;

    try {
      const data = await getUserActivity(companyId, empName);
      const ActivityData = data?.filter((item) => {
        const itemCreatedOn = new Date(item.createdOn.seconds * 1000);
        const start = new Date(startDate);
        const end = new Date(endDate);
        return itemCreatedOn >= start && itemCreatedOn <= end;
      });

      mapWidhtEmpList(ActivityData);
    } catch (error) {
      console.error("Error fetching report list data:", error);
    }
  };

  const renderRowCell = (
    rcellItem,
    hcellItem,
    index,
    rowindex,
    isMobile,
    isLandscape
  ) => {
    switch (hcellItem.id) {
      case "employeeName":
        // if (isMobile || isLandscape) {
        //     return null;
        // }
        if (
          rowindex !== 0 &&
          employeeList[rowindex - 1].employeeName !== rcellItem.employeeName
        ) {
          return <div className="b-none">{rcellItem[hcellItem?.id]} </div>;
        } else if (rowindex === 0) {
          return <div className="b-none">{rcellItem[hcellItem?.id]} </div>;
        } else {
          return "";
        }
      case "Action":
        if (isMobile || isLandscape) {
          if (rowindex === 0) {
            return (
              <ActionRender
                rcellItem={rcellItem}
                clientsListCSV={clientsListCSV}
                setDownloadCSVData={setDownloadCSVData}
                downloadPDF={downloadForPDF}
                downloadExcel={downloadForExcel}
                startDate={startDate}
                endDate={endDate}
                handleEmailIconClick={handleEmailIconClick}
                name={"ActivityReport"}
              />
            );
          } else {
            return null;
          }
        } else {
          if (
            rowindex !== 0 &&
            employeeList[rowindex - 1].employeNameId !== rcellItem.employeNameId
          ) {
            return (
              <ActionRender
                rcellItem={rcellItem}
                clientsListCSV={clientsListCSV}
                setDownloadCSVData={setDownloadCSVData}
                downloadPDF={downloadForPDF}
                downloadExcel={downloadForExcel}
                startDate={startDate}
                endDate={endDate}
                handleEmailIconClick={handleEmailIconClick}
                name={"ActivityReport"}
              />
            );
          } else if (rowindex === 0) {
            return (
              <ActionRender
                rcellItem={rcellItem}
                clientsListCSV={clientsListCSV}
                setDownloadCSVData={setDownloadCSVData}
                downloadPDF={downloadForPDF}
                downloadExcel={downloadForExcel}
                startDate={startDate}
                endDate={endDate}
                handleEmailIconClick={handleEmailIconClick}
                name={"ActivityReport"}
              />
            );
          } else {
            return "";
          }
        }
      default:
        return <div className="b-none">{rcellItem[hcellItem?.id]} </div>;
    }
  };

  const MobileViewData = useMemo(() => {
    if (!employeeList?.length) return [];

    return employeeList?.reduce((acc, item) => {
      const employeeName = item?.employeeName;

      const record = {
        id: item?.id,
        date: item?.date,
        version: item?.version,
        actions: item?.actions,
        employeNameId: item?.employeNameId,
        employeeName: item?.employeeName
      };

      const existingGroup = acc?.find((g) => g?.employeeName === employeeName);

      if (existingGroup) {
        existingGroup?.records?.push(record);
      } else {
        acc?.push({
          employeeName,
          records: [record],
        });
      }

      return acc;
    }, []);
  }, [employeeList]);

  const filteredEmployees = employee?.filter((item) =>
    empName?.includes(item?.id)
  );

    const handleEmailDialogClose = async() => {
      setOpenEmailDialog(false);
      await handleGenerateReport();
    }

  return (
    <>
      <Container>
        <PageTitle
          pageTitle="Activity Reports"
          showBreadcrumb={[
            { label: "Home", to: "/" },
            { label: "Reports" },
            { label: "New Reports" },
            { label: "Employee Reports", to: "/reports/newreport/employeereport" },
          ]}
          BreadCrumbCurrentPageTitle={"Activity Reports"}
          showLastSeen={true}
        ></PageTitle>

        <div className={`sectionBox2 dark:bg-[#1A1F2C]`}>
          <div className="mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 max-w-7xl dark:bg-[#1A1F2C]">
            <div className="space-y-6">
              <Card className="shadow-sm dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] p-24">
                <CardHeader className="pb-12">
                  <div className="flex items-center space-x-2">
                    <Filter className="w-4 h-4 sm:w-5 sm:h-5 text-primary" />
                    <CardTitle className="text-lg sm:text-xl">
                      Report Parameters
                    </CardTitle>
                  </div>
                  <CardDescription className="text-left text-sm sm:text-base">
                    Configure the parameters for your Activity report
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                    {/* Employee Select */}
                    <div className="flex flex-col space-y-1">
                      <Label
                        htmlFor="employee"
                        className="text-sm font-medium text-gray-700 dark:text-white"
                      >
                        Employee Name *
                      </Label>
                      <MultiSelectWithCheckbox
                        value={empName}
                        name="employeeName"
                        label="Employee Name"
                        onChange={(e) => handleEmpNameChange(e)}
                        contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                        itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                        options={empNameList}
                        className="w-full min-h-[40px] px-3 py-2"
                      />
                    </div>

                    {/* Start Date */}
                    <div className="flex flex-col space-y-1">
                      <Label
                        htmlFor="startDate"
                        className="text-sm font-medium text-gray-700 dark:text-white"
                      >
                        Start Date *
                      </Label>
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker
                          value={startDate}
                          onChange={(newValue) => {
                            setStartDate(newValue);
                            // if (newValue) {
                            //   setEndDate(moment());
                            // } else {
                            //   setEndDate(null);
                            // }
                          }}
                          maxDate={moment()}
                          views={["year", "month", "day"]}
                          inputFormat="YYYY-MM-DD"
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              size: "small",
                              fullWidth: true,
                              className: "customDateInput",
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </div>

                    {/* End Date */}
                    <div className="flex flex-col space-y-1">
                      <Label
                        htmlFor="endDate"
                        className="text-sm font-medium text-gray-700 dark:text-white"
                      >
                        End Date *
                      </Label>
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker
                          value={endDate}
                          onChange={(newValue) => {
                            setEndDate(newValue);
                            // if (!newValue) {
                            //   setStartDate(null);
                            // }
                          }}
                          maxDate={moment()}
                          views={["year", "month", "day"]}
                          inputFormat="YYYY-MM-DD"
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              size: "small",
                              fullWidth: true,
                              className: "customDateInput",
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                  <div className="flex justify-start sm:justify-end pt-8">
                    <Button
                      type="submit"
                      className="w-full sm:w-auto h-10 text-sm px-6"
                      onClick={() => handleGenerateReport()}
                    >
                      {loader ? (
                        <CircularProgress
                          size={28}
                          style={{ color: "white" }}
                        />
                      ) : (
                        <span className="d-flex flex-center">
                          <FileText className="w-4 h-4 mr-8" /> Generate Report
                        </span>
                      )}
                    </Button>
                  </div>
                </CardContent>
              </Card>

              {loader ? (
                <Card className="shadow-sm p-24 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] flex items-center justify-center min-h-[200px]">
                  <div className="text-sm sm:text-base text-gray-600 dark:text-gray-300">
                    Fetching report data...
                  </div>
                </Card>
              ) : employeeList?.length === 0 ? (
                <Card className="shadow-sm p-24 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] flex items-center justify-center min-h-[200px]">
                  <div className="text-sm sm:text-base text-gray-600 dark:text-gray-300">
                    No Records Found
                  </div>
                </Card>
              ) : (
                employeeList?.length > 0 && (
                  <Card className="shadow-sm p-24 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
                    <CardHeader className="pb-16">
                      <div className="flex flex-col space-y-4 lg:flex-row lg:items-start lg:justify-between lg:space-y-0">
                        <div className="space-y-3 flex-1 min-w-0">
                          <CardTitle className="text-lg sm:text-xl">
                            Report Results
                          </CardTitle>
                          <CardDescription className="space-y-2">
                            <div className="font-medium text-sm sm:text-base">
                              {empName?.[0] === "all" || empName?.length === 0
                                ? "All Employees Report"
                                : `Employee Report for ${filteredEmployees?.firstName} ${filteredEmployees?.lastName}`}
                            </div>
                            <div className="text-xs sm:text-sm text-gray-600 dark:text-gray-400">
                              {/* Check-in/Check-out Report - Date Range: {startDate} to {endDate} */}
                            </div>
                          </CardDescription>
                        </div>
                        <div className="flex flex-wrap gap-2">
                          <Button
                            variant="outline"
                            size="sm"
                            onClick={() => handelEmailFullReport()}
                            className="h-8"
                          >
                            <Mail className="mr-4 h-3 w-3" />
                            Email Report
                          </Button>
                          <Popover>
                            <PopoverTrigger asChild>
                              <Button
                                variant="outline"
                                size="sm"
                                className="h-8"
                              >
                                <Download className="mr-4 h-3 w-3" />
                                Download
                              </Button>
                            </PopoverTrigger>
                            <PopoverContent className="w-40">
                              <div className="space-y-2">
                                <Button
                                  variant="ghost"
                                  className="w-full justify-start h-8"
                                  onClick={() => downloadForFullPDF()}
                                >
                                  <FileText className="mr-8 h-3 w-3" />
                                  PDF
                                </Button>
                                <Button
                                  variant="ghost"
                                  className="w-full justify-start h-8"
                                  onClick={() => downloadForFullExcel()}
                                >
                                  <FileSpreadsheet className="mr-8 h-3 w-3" />
                                  Excel
                                </Button>
                                <CSVLink
                                  data={clientsListCSV}
                                  filename={`ActivityReport_${
                                    empName?.[0] === "all" ||
                                    empName?.length === 0
                                      ? "All"
                                      : `${filteredEmployees?.firstName} ${filteredEmployees?.lastName}`
                                  }_${moment(startDate).format(
                                    "YYYY-MM-DD"
                                  )}_${moment(endDate).format(
                                    "YYYY-MM-DD"
                                  )}.csv`}
                                  asyncOnClick={true}
                                  onClick={(event, done) => {
                                    setDownloadFullCSVData(event, done);
                                  }}
                                  className="w-full flex justify-start items-center h-8 pv-8 ph-16 text-sm hover:bg-accent hover:text-accent-foreground rounded-md transition-colors"
                                >
                                  <FileSpreadsheet className="mr-16 h-4 w-4" />
                                  <span className="font-medium">CSV</span>
                                </CSVLink>
                              </div>
                            </PopoverContent>
                          </Popover>
                        </div>
                      </div>
                    </CardHeader>
                    <CardContent className="p-0 sm:p-6 sm:pt-0">
                      {!isMobile && (
                        <ThemeTable
                          rows={employeeList}
                          headCells={getColumns()}
                          hidePagination={true}
                          renderRowCell={renderRowCell}
                        />
                      )}
                      {isMobile && (
                        <MobileActivityReport
                          MobileViewData={MobileViewData}
                          handleEmailIconClick={handleEmailIconClick}
                          downloadForPDF={downloadForPDF}
                          downloadForExcel={downloadForExcel}
                          clientsListCSV={clientsListCSV}
                          setDownloadCSVData={setDownloadCSVData}
                          startDate={startDate}
                          endDate={endDate}
                          reportName={"ActivityReport"}
                        />
                      )}
                    </CardContent>
                  </Card>
                )
              )}
            </div>
          </div>
        </div>
        <EmailReports
          open={openEmailDialog}
          onClose={() => handleEmailDialogClose()}
        />
      </Container>
    </>
  );
}

export default ActivityReportNew;
